@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/glass-house-business-card-stack-content/glass-house-business-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.5rem;
}
:host .card-content {
  position: relative;
  display: flex;
  height: 100%;
}
:host .sidebar-spacer {
  box-sizing: border-box;
  width: 1.5rem;
}
:host .sidebar-section {
  box-sizing: border-box;
  position: absolute;
  padding: 0.375rem 0.4375rem 0.5rem 0.5625rem;
  transform: rotate(90deg);
  transform-origin: top left;
  left: 1.5rem;
  text-transform: uppercase;
  border-color: #9f9f9f;
  border-style: solid;
  border-width: 0 0.0625rem 0.0625rem 0.0625rem;
  width: 9.0625rem;
  height: 1.5rem;
}
:host .sidebar-text {
  white-space: nowrap;
  font-family: inter, sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 0.5625rem;
}
:host .main-section {
  display: flex;
  flex: 1;
  flex-direction: column;
  border-width: 0.0625rem;
  border-color: #9f9f9f;
  border-style: solid;
}
:host .card-top {
  display: flex;
  justify-content: space-between;
  height: 4.5rem;
  max-height: 4.5rem;
  border-bottom: 0.0625rem #9f9f9f solid;
  padding: 0.5625rem 0.5625rem 0.3125rem 0.5625rem;
}
:host .title-brand-and-label-container {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
:host .product-card-name {
  line-height: 1.1;
  word-break: break-word;
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1.375rem;
}
:host .brand-and-label {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
:host .product-card-brand {
  font-size: 0.875rem;
  font-family: inter, sans-serif;
  font-weight: 800;
  font-style: normal;
  opacity: 0.38;
}
:host .print-card-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .print-card-label ::ng-deep .product-label {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5rem;
  border-radius: 0.125rem;
  line-height: 100%;
  padding: 0.2rem 0.1875rem 0.125rem 0.1875rem;
  width: fit-content;
}
:host .product-card-badge-container {
  display: flex;
  flex-direction: column;
  width: 1rem;
  gap: 0.4375rem;
}
:host .product-card-badge-container .product-card-badge {
  width: 1rem;
}
:host .card-bottom {
  display: flex;
  justify-content: space-between;
  flex: 1;
  padding-top: 0.3125rem;
}
:host .properties-and-size-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-left: 0.5625rem;
}
:host .property-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.1875rem;
}
:host .property-container .title {
  font-family: inter, sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 0.625rem;
  opacity: 0.38;
}
:host .property-container .value {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 0.75rem;
}
/*# sourceMappingURL=glass-house-business-card-stack-content.component.css.map */
